import firebase from "firebase/app";
import requestAxios from "@/helpers/request_axios";
//import { activityTypes } from "@/helpers/get_constants";
import * as MutationsType from "./mutationsType";
import {
  // serverTimestamp,
  contactsTimelinesCollection,
  ticketsTimelinesCollection,
  ordersTimelinesCollection,
} from "@/config/firebase";

export default {
  // eslint-disable-next-line
  async fetchContactTimeline({ commit }, payload) {
    contactsTimelinesCollection
      .doc(payload.contact_id)
      .collection("comments")
      .onSnapshot(async (snap) => {
        snap.docs.forEach((doc) => {
          commit(MutationsType.ADD_CONTACT_ACTIVITY, { ...doc.data(), id: doc.id, contactId: payload.contact_id });
        });
      });
  },
  // eslint-disable-next-line
  async getTicketTimeline({ commit, state }, payload) {
    const existTicketTimeline = state.timelineTicketIds.find((ticketId) => ticketId === payload.ticket_id);
    if (existTicketTimeline) return;

    ticketsTimelinesCollection
      .doc(payload.ticket_id)
      .collection("comments")
      .onSnapshot(async (snap) => {
        snap.docChanges().forEach((change) => {
          if (change.type === "added") {
            let comment = change.doc.data();
            commit(MutationsType.ADD_ACTIVITY, {
              ...comment,
              id: change.doc.id,
              ticketId: payload.ticket_id,
            });
            /*
            let dataToUpdate = {};

            if (comment.type === activityTypes.COMMENT && comment.uid) {
              dataToUpdate.comment_text = comment.text;
              dataToUpdate.date_comment = comment.created_at;
            }

            if (comment.uid) {
              dataToUpdate.agent_comment_text = comment.text;
              dataToUpdate.date_agent_comment = comment.created_at;
            }

            if (Object.keys(dataToUpdate).length) {
              commit("UPDATE_TICKET", { id: payload.ticket_id, add_value: dataToUpdate });
            }
            */
          }

          if (change.type === "modified") {
            commit(MutationsType.UPDATE_ACTIVITY, { ...change.doc.data(), id: change.doc.id });
          }
        });
        // snap.docs.forEach((doc) => {
        //   commit(MutationsType.ADD_ACTIVITY, { ...doc.data(), id: doc.id, ticketId: payload.ticket_id });
        // });
      });

    commit(MutationsType.ADD_TIMELINE_TICKET_IDS, { id: payload.ticket_id });
  },
  // eslint-disable-next-line
  async getTicketTimelineCommentMedia({}, { id, commentId }) {
    try {
      return await requestAxios({
        url: `/awy/api/v1/ticket/${id}/comments/${commentId}/media`,
        method: "GET",
        responseType: "blob",
      });
    } catch (error) {
      throw error.response.data;
    }
  },
  async getOrderTimeline({ commit }, { id }) {
    ordersTimelinesCollection
      .doc(id)
      .collection("comments")
      .orderBy("created_at", "asc")
      .onSnapshot(async (snap) => {
        snap.docs.forEach((doc) => {
          commit(MutationsType.ADD_ACTIVITY, { ...doc.data(), id: doc.id });
        });
      });
  },
  // eslint-disable-next-line
  async addActivity({ rootState }, payload) {
    const agent = rootState.Agent.agent;
    if (["advisor_level2", "supervisor"].includes(agent.role) && rootState.Ticket.ticket?.agent_id !== agent.uid)
      throw new Error("No tienes permiso para comentar");

    const comment = payload.comment;
    let collection, timeline_id;
    let activity = {
      text: comment.text,
      type: comment.type,
      uid: agent.uid,
      team_id: agent.team_id || "",
      created_at: firebase.firestore.Timestamp.now().toDate(),
    };

    if (activity.type === 4) {
      activity.detail = comment.text;

      if (comment.event_name && comment.text) activity.text = `${comment.event_name}: ${comment.text}`;
      else activity.text = `Se programó un evento de tipo ${comment.event_type}`;

      activity.event_name = comment.event_name;
      activity.event_date = comment.date_start;
      activity.event_time = comment.time_start;
      activity.event_time_end = comment.time_end;
      activity.event_type = comment.event_type;
    }

    if (payload.contact_id) {
      collection = contactsTimelinesCollection;
      timeline_id = payload.contact_id;
      activity.contact_id = payload.contact_id;
    } else {
      collection = ticketsTimelinesCollection;
      timeline_id = payload.ticket_id;
      activity.ticket_id = payload.ticket_id;
    }

    collection.doc(timeline_id).collection("comments").add(activity);
  },
  async updateTicketTimelineActivity({ state, commit }, { id, activityId, data }) {
    const existTicketTimeline = state.timelineTicketIds.find((ticketId) => ticketId === id);
    if (!existTicketTimeline) return;

    commit(MutationsType.UPDATE_ACTIVITY, { ...data, id: activityId });
  },
  // eslint-disable-next-line
  async exportContactActivityTemplate({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/contact/export-template-activities",
        method: "GET",
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async importContactActivities({ commit }, payload) {
    try {
      let formdata = new FormData();
      formdata.append("file", payload.file);
      let response = await requestAxios({
        url: "/awy/api/v1/contact/import-activities",
        method: "POST",
        data: formdata,
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async exportTicketActivityTemplate({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ticket/export-template-activities",
        method: "GET",
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async importTicketActivities({ commit }, payload) {
    try {
      let formdata = new FormData();
      formdata.append("file", payload.file);
      let response = await requestAxios({
        url: "/awy/api/v1/ticket/import-activities",
        method: "POST",
        data: formdata,
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleTimeline({ commit }) {
    commit(MutationsType.SET_TIMELINE, []);
  },
};
